import { FlexDetails } from 'ggApp/types/graphql';

import ActionTypes from './actionTypes';
import { Action } from './actions';

export const defaultState: SubscriptionDetailsCardStateType = null;

export type SubscriptionDetailsCardStateType = FlexDetails | null;

export default function reducer(
    state: SubscriptionDetailsCardStateType = defaultState,
    action: Action,
): SubscriptionDetailsCardStateType {
    if (action.type === ActionTypes.CREATE_SUBSCRIPTION_DETAILS_CARD) {
        const { payload: detailsCard } = action;

        return {
            ...detailsCard,
        };
    }

    if (action.type === ActionTypes.UPDATE_SUBSCRIPTION_DETAILS_CARD) {
        const { payload: detailsCard } = action;

        if (state === defaultState) {
            return defaultState;
        }

        return {
            ...state,
            ...detailsCard,
        } as FlexDetails;
    }

    return state;
}
